<template>
  <div class="main-container my-modal" :class="{ 'add-modal': isAdd, top: !isAdd }">
    <div class="left">
      <div class="bg" ref="title1">
        <span class="line"></span>
        <span class="title">活动详情</span>
      </div>
      <Form ref="form" :model="formData" :label-width="100" class="page-form">
        <FormItem prop="id" label="活动ID" class="full" v-if="((!isAdd&&formData.id) || (isAdd&&isSave&&formData.id) || (isAdd&&formData.id)) && ($units.isOkBao() || $units.isOkTX())">
          <div class="url-box">
            <Input v-model="formData.id" disabled />
            <Button type="primary" class="preview" @click="copyId(formData.id)">复制</Button>
          </div>
        </FormItem>
        <FormItem prop="name" label="活动名称" :rules="$units.formRule.required('请输入活动名称')" class="ivu-form-item">
          <Input v-model="formData.name" maxlength="18" placeholder="最多不超过18个字" />
        </FormItem>
        <FormItem prop="startTime" label="开始时间" :rules="$units.formRule.required('请选择')" class="ivu-form-item">
          <DatePicker
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            :value="formData.startTime"
            @on-change="formData.startTime = $event"
            split-panels
            placeholder="选择日期"
            :disabled="formData.status == 1"
          ></DatePicker>
        </FormItem>
        <FormItem prop="endTime" label="结束时间" :rules="$units.formRule.required('请选择')" class="ivu-form-item">
          <DatePicker
            :transfer="true"
            format="yyyy-MM-dd"
            placement="bottom"
            :value="formData.endTime"
            @on-change="formData.endTime = $event"
            split-panels
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem prop="description" label="活动简介" :rules="$units.formRule.required('请输入活动简介')" class="ivu-form-item">
          <Input type="textarea" :rows="6" v-model="formData.description" placeholder="请输入活动简介" />
        </FormItem>
        <FormItem prop="remark" label="备注" class="ivu-form-item">
          <Input v-model="formData.remark" type="textarea" :rows="6" placeholder="请输入备注" />
        </FormItem>
        <FormItem prop="img" label="活动图片" :rules="$units.formRule.arrRequired('请上传活动图片', (trigger = 'change'))" class="ivu-form-item">
          <div class="upload-container">
            <upLoadNew v-model="formData.img" @change="uploadChange"></upLoadNew>
            <div class="upload-img-tip">图片尺寸为690px*220px</div>
          </div>
        </FormItem>
        <FormItem prop="urlType" label="活动页地址" v-if="$units.isOkBao() || $units.isOkTX()">
          <RadioGroup v-model="formData.urlType">
            <Radio :label="0">系统默认</Radio>
            <Radio :label="1">自定义</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="urlPath" class="two" label="活动页链接" :rules="[$units.formRule.required('自定义活动页时地址不能为空'), $units.formRule.url()]" v-if="formData.urlType">
          <div class="url-box">
            <Input class="describe-inp" type="textarea" :rows="6" placeholder="自定义活动页地址时此项必填" v-model="formData.urlPath" />
            <Button type="primary" class="preview" @click="previewH5Activity">预览</Button>
          </div>          
          <span class="describe-url">自定义地址规范：页面路径”+“?ids=活动id,活动id,活动id”，如: https://h5{{`${this.$config.env==0||this.$config.env == 2?'-test':''}`}}.lazhuyun.cn/apps/activityCenter/okApp/202401/01?ids=1754398763936972802 如活动页包含了多个活动，请用英文逗号隔开。请注意：若为新建页面活动ID还未生成，请保存后在页面顶部获取活动ID</span>
        </FormItem>
        <FormItem prop="rule" label="活动规则" :rules="$units.formRule.required('请输入活动规则')" class="full">
          <editor ref="editorRef" v-model="formData.rule" placeholder="请输入活动规则"></editor>
        </FormItem>
      </Form>
    </div>
    <div class="right">
      <template v-if="isAdd == '1' || formData.status == 0 || formData.status == 1">
        <div class="bg">
          <span class="line"></span>
          <span class="title">规则配置</span>
          <span class="tips">说明：加费类型下的活动总奖励 = 计算因子 * 活动奖励，活动仅针对首年年交产品</span>
        </div>
        <!-- 增员活动 -->
        <configContent
          v-show="activityType == 1"
          ref="configContent"
          compontntType="addModal"
          :activityType="activityType"
          :tableList="tableList"
          :id="formData.id"
          @typeChange="typeChange"
        />
        <!-- 出单活动 -->
        <configContentOrder
          v-show="activityType == 2"
          ref="configContentOrder"
          compontntType="addModal"
          :activityType="activityType"
          :id="formData.id"
          :tableList="tableList"
          @typeChange="typeChange"
        />
        <!-- 签约活动 -->
        <configContentSign
          v-show="activityType == 3"
          ref="configContentSign"
          compontntType="addModal"
          :activityType="activityType"
          :id="formData.id"
          :tableList="tableList"
          @typeChange="typeChange"
        />
        <!-- 报名活动 -->
        <configContentSignUp
          v-show="activityType == 4"
          ref="configContentSignUp"
          compontntType="addModal"
          :activityType="activityType"
          :id="formData.id"
          :tableList="tableList"
          @typeChange="typeChange"
        />

        <div
          class="bg"
          v-if="(activityType == 2 && formData.calculateType == '0') || (activityType == 1 && formData.mode == '2' && [3, 6].includes(formData.conditionalIndicator*1))"
          style="margin: 20px 0"
        >
          <span class="line"></span>
          <span class="title">产品配置</span>
          <span class="tips">说明：活动仅支持首期年交产品参加，产品不限制上架及销售状态</span>
        </div>
        <configContentProductList
          :status="formData.status"
          :activityId="formData.id"
          :isAdd="isAdd"
          :syncProductType='formData.syncProductType'
          :productType="formData.productType"
          ref="configContentProductList"
          v-if="
            (formData.type == 2 && formData.mode == 2 && formData.calculateType == '0') || (activityType == 1 && formData.mode == '2' && [3, 6].includes(formData.conditionalIndicator*1))"
          @addSaveForm="addSaveForm(false, (showTips = false))"
          @setSyncProductType='getSyncProductType'
        >
        </configContentProductList>

        <addProduct
          ref="addProduct"
          compontntType="addModal"
          :status="formData.status"
          :id="formData.id"
          :mode="formData.mode"
          :type="formData.type"
          v-show="formData.type == 2 && formData.mode == 1"
          :isAdd="isAdd"
        />
      </template>
    </div>
    <div style="height: 110px" v-if="isAdd == '1' || formData.status == 0 || formData.status == 1"></div>

    <div class="footer-action">
      <div>
        <Button type="primary" ghost @click="backPage()">返回</Button>
        <!-- (出单，梯度) -->
        <Button type="primary" class="btn" @click="addSaveForm(true, (showTips = true))" :loading="saveLoading" v-if="formData.type == 2 && formData.mode == 2"
          >保存</Button
        >

        <Button type="primary" class="btn" @click="submit" :loading="saveLoading" v-else>保存</Button>
      </div>
    </div>

    <!-- 出单-梯度产品选择 -->
    <configContentSelectProduct ref="selcetProduct" @success="addSelectProduct"></configContentSelectProduct>
  </div>
</template>

<script>
import configContent from './components/configContent';
import configContentOrder from './components/configContentOrder';
import configContentSign from './components/configContentSign';
import configContentSignUp from './components/configContentSignUp';
import addProduct from './components/addProduct';
import configContentProductList from './components/configContentProductList';
import configContentSelectProduct from './components/configContentSelectProduct';
import editor from '@/components/commons/editor';
import upLoadNew from '@/components/commons/uploadNew';
import filters from '@/api/filter';
import { common } from '@/api/mixins';
export default {
  components: {
    configContent,
    configContentOrder,
    configContentSign,
    configContentSignUp,
    addProduct,
    editor,
    upLoadNew,
    configContentProductList,
    configContentSelectProduct
  },
  mixins: [common],
  data() {
    return {
      visible: false,
      isAdd: false,
      formData: {
        syncProductType: 0,
        startTime: '',
        endTime: '',
        urlType: 0
      },
      tableList: [],
      activityType: '1', //活动类型
      productType: '',
      saveLoading: false,
      isSave: false,//是否点击过保存
    };
  },
  created() {
    if (this.$route.query.isAdd == 1) {
      this.isAdd = true;
      this.visible = true;
    } else {
      this.open();
    }
  },
  methods: {
    open() {
      this.isAdd = this.$route.query.isAdd;
      this.visible = true;
      this.formData = {};
      let data = this.$route.query.data;
      if (this.$route.query.isAdd == '0') {
        // 编辑时回填数据
        this.formData = {
          ...data,
          startTime: data.startTime ? data.startTime : '',
          endTime: data.endTime ? data.endTime : '',
          img: [{ path: data.img }]
        };
        // status 0 未开始 1 进行中 -1 已结束
        if (data.status == '0' || data.status == 1) {
          this.activityType = data.type;
          this.$nextTick(() => {
            if (data.status == 1) {
              this.$refs.editorRef.setDisabled(true);
            }
            if (data.type == 1) {
              this.$refs.configContent && this.$refs.configContent.setData(this.formData);
            } else if (data.type == 2) {
              this.$refs.configContentOrder && this.$refs.configContentOrder.setData(this.formData);
            } else if (data.type == 3) {
              this.$refs.configContentSign && this.$refs.configContentSign.setData(this.formData);
            } else if (data.type == 4) {
              this.$refs.configContentSignUp && this.$refs.configContentSignUp.setData(this.formData);
            }
          });
        }
      }
    },

    submit() {
      this.$units.notCloseModal(this);
      let day = filters.filterTime(new Date(), 'YYYY-MM-DD');
      let endTime = filters.filterTime(this.formData.endTime, 'YYYY-MM-DD');
      // 活动信息校验
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.isAdd == '1') {
            // 规则校验
            if (this.activityType == 1) {
              //增员活动提交
              this.$refs.configContent.validate().then(res => {
                const gradientConfigs = this.$refs.configContent.gradientConfigs || [];
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs);
                }
              });
            } else if(this.activityType == 2) {
              // 出单活动提交
              this.$refs.configContentOrder.validate().then(async res => {
                const gradientConfigs = this.$refs.configContentOrder.gradientConfigs || [];
                const productJoins = await this.$refs.addProduct.ok();
                // 无门槛
                if (res.mode == 1) {
                  productJoins.map(item => {
                    if (item.programJoins && !item.programJoins.length) {
                      this.$Message.error('请配置活动产品及活动服务费');
                      return;
                    }
                    item.programJoins = item.programJoins && item.programJoins.filter(item2 => item2.rewardRate);
                  });
                }
                if (res.mode == 1 && !productJoins.length) {
                  this.$Message.error('请配置活动产品及活动服务费');
                  return;
                }
                if (res.mode == 2 && !gradientConfigs.length) {
                  this.$Message.error('请配置梯度活动奖励');
                  return;
                }
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs, productJoins);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs, productJoins);
                }
              });
            } else if (this.activityType == 3) {
              //签约活动
              this.$refs.configContentSign.validate().then(res => {
                const gradientConfigs = this.$refs.configContentSign.gradientConfigs || [];
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs);
                }
              });
            } else if(this.activityType == 4) {
              this.save(this.formData);
            }
          } else {
            if (this.formData.status != '0' && this.formData.status != '1' || ((this.formData.status == '0' || this.formData.status == '1') && this.activityType == 1)) {
              if (endTime < day) {
                this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                  //增员活动提交
                  if (this.formData.status == '0' || this.formData.status == '1') {
                    const gradientConfigs = this.$refs.configContent.gradientConfigs || [];
                    this.$refs.configContent.validate().then(res => {
                      this.save({ ...this.formData, ...res }, gradientConfigs);
                    });
                  } else {
                    this.save({ ...this.formData });
                  }
                });
              } else {
                //增员活动提交
                if (this.formData.status == '0' || this.formData.status == '1') {
                  const gradientConfigs = this.$refs.configContent.gradientConfigs || [];
                  this.$refs.configContent.validate().then(res => {
                    this.save({ ...this.formData, ...res }, gradientConfigs);
                  });
                } else {
                  this.save({ ...this.formData });
                }
              }
              return;
            }
            // 规则校验
            if (this.activityType == 1) {
              //增员活动提交
              this.$refs.configContent.validate().then(res => {
                const gradientConfigs = this.$refs.configContent.gradientConfigs || [];
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs);
                }
              });
            } else if (this.activityType == 2) {
              // 出单活动提交
              this.$refs.configContentOrder.validate().then(async res => {
                const gradientConfigs = this.$refs.configContentOrder.gradientConfigs || [];
                let productJoins = await this.$refs.addProduct.ok();
                let addProduct = JSON.parse(JSON.stringify(this.$refs.addProduct.addProduct));
                let addProductArr = JSON.parse(JSON.stringify(this.$refs.addProduct.addProduct));

                // 无门槛编辑
                if (res.mode == 1) {
                  addProduct.map(item => {
                    productJoins.map(item2 => {
                      if (item.productCode == item2.productCode) {
                        item.programJoins = item2.programJoins;
                      }
                    });
                  });
                  productJoins.map(item => {
                    addProductArr.map(item2 => {
                      if (!item.programJoins && item.productCode == item2.productCode) {
                        item.programJoins = item2.programJoins;
                      }
                    });
                  });
                  productJoins.map(item => {
                    item.programJoins = item.programJoins && item.programJoins.filter(itemObj => itemObj.rewardRate);
                  });
                } else {
                  // 梯度编辑
                  addProduct.map(item => {
                    productJoins.map(item2 => {
                      if (item.productCode == item2.productCode) {
                        item.programJoins = item2.programJoins;
                      }
                    });
                  });
                  productJoins.map(item => {
                    addProductArr.map(item2 => {
                      if (!item.programJoins && item.productCode == item2.productCode) {
                        item.programJoins = item2.programJoins;
                      }
                    });
                  });
                }
                if (res.mode == 1 && !productJoins.length) {
                  this.$Message.error('请配置活动产品及活动服务费');
                  return;
                }
                if (res.mode == 2 && !gradientConfigs.length) {
                  this.$Message.error('请配置梯度活动奖励');
                  return;
                }
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs, productJoins);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs, productJoins);
                }
              });
            } else if (this.activityType == 3) {
              //签约活动
              this.$refs.configContentSign.validate().then(res => {
                const gradientConfigs = this.$refs.configContentSign.gradientConfigs || [];
                if (endTime < day) {
                  this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
                    this.save({ ...this.formData, ...res }, gradientConfigs);
                  });
                } else {
                  this.save({ ...this.formData, ...res }, gradientConfigs);
                }
              });
            } else if(this.activityType == 4) {
              this.save(this.formData);
            }
          }
        } else {
          //校验不通过滚动到活动详情
          this.$refs.title1.scrollIntoView();
        }
      });
    },
    save(params, gradientConfigs, productJoins) {
      if (params.startTime) {
        params.startTime = filters.filterTime(params.startTime, 'YYYY-MM-DD');
      }
      if (params.endTime) {
        params.endTime = filters.filterTime(params.endTime, 'YYYY-MM-DD');
      }
      if (params.hasEnd == 1) {
        delete params.startTime;
        delete params.endTime;
      }
      // 出单-梯度
      if(params.type == 2 && params.mode == 2) {
        gradientConfigs && gradientConfigs.forEach(item => {
        if (params.rewardType == 3) {
            delete item.rateReward;
          }
        });
      }else if(params.type == 3) {
        // 签约活动
        gradientConfigs && gradientConfigs.forEach(item => {
          delete item.cashReward;
          delete item.kindReward;
          if(item.rewardSelect == 'cashReward') {
            item.cashReward = item.value;
          } else if(item.rewardSelect == 'kindReward') {
            item.kindReward = item.value;
          }
        })
      }else if(params.type == 1 && params.mode == 2 && [3, 6].includes(params.conditionalIndicator*1)) {
        if(params.rewardType == 1) {
          gradientConfigs = gradientConfigs && gradientConfigs.map(item => {
            delete item.cashReward;
            delete item.kindReward;
            return {
              ...item,
              rateReward: item.value
            }
          })
        }else if(params.rewardType == 2) {
          gradientConfigs = gradientConfigs && gradientConfigs.map(item => {
            delete item.cashReward;
            delete item.rateReward;
            return {
              ...item,
              kindReward: item.value
            }
          })
        }else{
          gradientConfigs = gradientConfigs && gradientConfigs.map(item => {
            delete item.kindReward;
            delete item.rateReward;
            return {
              ...item,
              cashReward: item.value
            }
          })
        }
        gradientConfigs && gradientConfigs.forEach(item=>{
          delete item.value;
        })
      }else if (params.type == 1 && params.mode == 2 && params.conditionalIndicator == 1) {
        gradientConfigs = gradientConfigs && gradientConfigs.map(item=> {
          if(item.rewardSelect == 'kindReward') {
            item.kindReward = item.value;
          }else if(item.rewardSelect == 'cashReward') {
            item.cashReward = item.value;
          }
          return {
            ...item
          }
        })
        gradientConfigs && gradientConfigs.forEach(item=>{
          delete item.value;
        })
      }
      this.saveLoading = true;
      this.$http({
        url: (params.type == 2 && params.mode == 2) || (params.type == 1 && params.mode == 2) ? '/buz/merchantActivity/saveActivity' : '/buz/merchantActivity/save',
        type: 'post',
        data: {
          merchantActivity: {
            ...params,
            img: this.formData.img[0].path
          },
          gradientConfigs,
          productJoins
        }
      })
        .then(res => {
          this.formData.id = res.data.id;
          this.isSave = true;          
          this.$notice.success('保存成功');
          this.setPageTitle('编辑活动');
          this.visible = false;          
          // this.back();          
          if (this.isAdd) {
            this.$parent.getList();
          }
          this.saveLoading = false;
        })
        .catch(() => {
          this.saveLoading = false;
          this.$units.notCloseModal(this);
        });
    },
    uploadChange() {
      this.$refs.form.validateField('img');
    },
    typeChange(data) {
      this.$set(this, 'activityType', data.type);
      this.$set(this.formData, 'type', data.type);
      this.$set(this.formData, 'mode', data.mode);
      this.$set(this, 'productType', data.productType);
      this.$set(this.formData, 'productType', data.productType);
      this.$set(this.formData, 'calculateType', data.calculateType);
      this.$set(this.formData, 'conditionalIndicator', data.conditionalIndicator);
      this.$set(this.formData, 'joinType', data.joinType);
      this.$set(this.formData, 'rewardType', data.rewardType);
      this.$set(this.formData, 'calFactor', data.calFactor);
      this.$set(this.formData, 'needSignup', data.needSignup);      
      
      if (this.isAdd == '1') {
        this.$refs.addProduct.searchAjax();
      }
    },
    visibleChange(v) {
      if (!v && this.isAdd) {
        this.back('/activityManage/recruiting');
      }
    },
    addSaveForm(open, showTips) {
      // 新增
      if (this.formData.type == 2 && this.formData.mode == 2) {
        if ((this.formData.status == '0' || this.formData.status == '1' || this.isAdd == '1') && !this.$refs.configContentOrder.gradientConfigs.length) {
          this.$Message.error('请配置梯度活动奖励');
          return;
        }
      } else if (this.formData.type == 1 && this.formData.mode == 2) {
        if ((this.formData.status == '0' || this.formData.status == '1' || this.isAdd == '1') && !this.$refs.configContent.gradientConfigs.length) {
          this.$Message.error('请配置梯度活动奖励');
          return;
        }
      }

      this.$refs.form.validate(async valid => {
        if (valid) {
          let day = filters.filterTime(new Date(), 'YYYY-MM-DD');
          let endTime = filters.filterTime(this.formData.endTime, 'YYYY-MM-DD');
          if (endTime < day && showTips) {
            this.$notice.inquiry(`请确认结束时间是否正确，确认后活动细则及奖励将无法修改`).then(() => {
              if (this.$refs.configContentOrder) {
                this.$refs.configContentOrder.validate().then(async res => {
                  this.saveAdd(res, open);
                });
              } else {
                this.saveAdd({}, open);
              }
            });
          } else {
            if (this.$refs.configContentOrder) {
              this.$refs.configContentOrder.validate().then(async res => {
                this.saveAdd(res, open);
              });
            } else {
              this.saveAdd({}, open);
            }
          }
        } else {
          //校验不通过滚动到活动详情
          this.$refs.title1.scrollIntoView();
        }
      });
    },

    saveAdd(obj, open) {
      // 编辑打开弹窗
      // if (this.isAdd == '0' && !open && this.formData.id) {
      //   this.$refs.selcetProduct.open(this.formData.id); //编辑新增产品
      // } else if (this.isAdd == '0' && open && this.formData.id) {
      //   this.saveAddSubmit(obj, true, 'product'); //编辑保存
      // } else if (this.isAdd == '1' && !open && !this.formData.id) {
      //   this.saveAddSubmit(obj, false, 'product'); //新增
      // } else if (this.isAdd == '1' && open && this.formData.id) {
      //   this.saveAddSubmit(obj, true, 'product'); //新增
      // } else if (this.isAdd == '1' && open && !this.formData.id) {
      //   this.saveAddSubmit(obj, true, 'product'); //新增
      // } else if (this.isAdd && !open && this.formData.id) {
      //   this.saveAddSubmit(obj, false, 'product'); //二次新增
      // }
      if ((this.isAdd == '0' && !open && this.formData.id) || (this.formData.id && !open)) {
        this.$refs.selcetProduct.open(this.formData.id);
      } else if ((this.isAdd == '1' && !open && !this.formData.id) || (this.isAdd && !open && this.formData.id)) {
        this.saveAddSubmit(obj, false, 'product');
      } else if (
        (this.isAdd == '0' && open && this.formData.id) ||
        (this.isAdd == '1' && open && this.formData.id) ||
        (this.isAdd == '1' && open && !this.formData.id)
      ) {
        this.saveAddSubmit(obj, true, 'product');
      }
    },

    saveAddSubmit(obj, isBack, type) {
      let startTime = filters.filterTime(this.formData.startTime, 'YYYY-MM-DD');
      let endTime = filters.filterTime(this.formData.endTime, 'YYYY-MM-DD');
      let merchantActivity = {
        ...obj,
        ...this.formData,        
        img: this.formData.img[0].path,
        startTime,
        endTime
      };
      let gradientConfigs = JSON.parse(JSON.stringify(this.$refs.configContentOrder ? this.$refs.configContentOrder.gradientConfigs : []));
      gradientConfigs &&
        gradientConfigs.forEach(item => {
          if (obj.rewardType == 3) {
            item.cashReward = item.rewardValue || item.rateReward;
            delete item.rateReward;
          } else {
            delete item.cashReward;
          }
        });
      this.$http({
        url: (merchantActivity.type == 2 && merchantActivity.mode == 2) || (merchantActivity.type == 1 && merchantActivity.mode == 2)? '/buz/merchantActivity/saveActivity' : '/buz/merchantActivity/save',
        type: 'POST',
        data: {
          merchantActivity,
          gradientConfigs
        }
      }).then(res => {
        this.$set(this.formData, 'id', res.data.id); 
        if (isBack) {
          // this.back();   
          this.$set(this, 'isSave', true);             
          this.$notice.success('保存成功');
          this.setPageTitle('编辑活动');
        } else {
          if (type == 'product') {
            this.$refs.selcetProduct.open(res.data.id);
            return
          }
          this.$set(this, 'isSave', true);
          this.formData = res.data;
        }
      });
    },

    getSyncProductType(value) {
      this.formData.syncProductType = value;
    },

    addSelectProduct() {
      this.$refs.configContentProductList.searchAjax();
    },

    // 返回
    backPage() {
      if (this.isAdd == '1' && this.formData.id && !this.isSave) {
        this.$http({
          url: '/buz/merchantActivity/del',
          type: 'DELETE',
          data: {
            id: this.formData.id
          }
        }).then(res => {
          this.back();
        });
      } else {
        this.back();
      }
    },

    // 复制id
    copyId(value) {
      let oInput = document.createElement('input');
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.remove();
      this.$Message.success('ID复制成功');
    },

    // 链接预览
    previewH5Activity() {
      const urlPath = this.formData.urlPath;
      if(!urlPath) {
        this.$notice.msg('请填写活动页链接');
        return
      }
      let url = urlPath + (urlPath.includes('?') ? '&preview=1' : '?preview=1');
      window.open(url, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.bg {
  display: flex;
  align-items: center;
  height: 40px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #f4f8ff 100%);
  padding-left: 15px;
  margin-bottom: 10px;
  .line {
    height: 12px;
    width: 3px;
    background: #236dff;
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
    margin-left: 5px;
  }
  .tips {
    margin-left: 20px;
    font-size: 12px;
    color: #727c8e;
  }
}
.add-modal {
  /deep/.ivu-modal-body {
    > div {
      .title {
        height: 40px;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #f4f8ff 100%);
        display: flex;
        align-items: center;
        color: #3c464f;
        font-weight: 600;
        padding-left: 24px;
        position: relative;
        &::before {
          content: '';
          width: 3px;
          height: 12px;
          background: #236dff;
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
        }
      }
    }
    .tip {
      background: #f9fafc;
      border-radius: 4px 4px 4px 4px;
      color: #3f6ec9;
      padding: 10px 14px;
    }
  }
}
.my-modal {
  .half {
    width: 50%;
  }
  .half-25 {
    width: 25%;
  }
  /deep/.ivu-modal-body {
    .title {
      height: 40px;
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #f4f8ff 100%);
      display: flex;
      align-items: center;
      color: #3c464f;
      font-weight: 600;
      padding-left: 24px;
      position: relative;
      &::before {
        content: '';
        width: 3px;
        height: 12px;
        background: #236dff;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
      }
    }
  }
}
.top {
  /deep/.ivu-modal-body {
    padding-top: 10px;
  }
}
.editor /deep/ .w-e-text-container {
  min-height: 200px !important;
}
.footer-action {
  position: fixed;
  bottom: 0px;
  background: #fff;
  z-index: 1;
  width: 100%;
  left: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.12);
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
.upload-container {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  .upload-img-tip {
    margin-top: auto;
    color: #a8adb7;
    font-size: 12px;
    margin-left: 10px;
  }
   /deep/.uploadBoxs {
    width: 690px;
    img {
      width: 690px !important;
    }
  }
  /deep/.demo-upload-list {
    width: 690px;
    img {
      width: 690px !important;
    }
  }
}
/deep/ .w-e-text-container {
  border: 1px solid #e3e5e8 !important;
  border-top: none !important;
}
/deep/ .w-e-toolbar {
  border: 1px solid #e3e5e8 !important;
}
.describe-inp {
  word-break:break-all; //只对英文起作用，以字母作为换行依据
}
.describe-url {
  color: #333;
  font-size: 12px;
  word-break:break-all; //只对英文起作用，以字母作为换行依据
}
.url-box {
  display: flex;
  align-items: center;
  .preview {
    margin-left: 20px;
  }
}
</style>
